import { useState } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'

import styles from './ArticleBottomDescription.module.scss'

export type ArticleBottomDescriptionProps = {
	description: string
	title?: string
}

/** A component that displays the description of the promotion.
 *  @param props
 *  @param props.description
 *  @param props.title
 * */
export const ArticleBottomDescription = ({ description, title }: ArticleBottomDescriptionProps): JSX.Element => {
	const [isOpen, setIsOpen] = useState<boolean>(true)
	const textClassName = [styles.text]
	if (!isOpen) textClassName.push(styles.text_closed)

	return (
		<div className={styles.articleBottomDescription}>
			{title && <h3 className={styles.descriptionTitle} dangerouslySetInnerHTML={createMarkup(title)} />}
			<span className={textClassName.join(' ')} dangerouslySetInnerHTML={createMarkup(description)} />
			<Button className={styles.hideButton} theme="link" onClick={() => setIsOpen(!isOpen)}>
				{isOpen ? `Спрятать` : `Показать`}
			</Button>
		</div>
	)
}
